import React, { useEffect, useState } from 'react';
import axios from '../../helpers/axios';
import OrderDialog from './OrderDialog';
import { orderError } from '../../actions/api/order';

function Attachment({ orderId, screen, onClose }) {
  const [asset, setAsset] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    let url = '';
    axios.get(`/order/${orderId}/screens/${screen._id}`, { responseType: 'blob' }).then(({ data }) => {
      if (!active) return;
      url = URL.createObjectURL(data); setAsset({ url, type: data.type });
    }).catch(async (cause) => {
      if (!active) return;
      let message = orderError(cause);
      if (cause.response?.data instanceof Blob) { try { const data = JSON.parse(await cause.response.data.text()); message = data.error || data.message || message; } catch (_) { /* Оставляем текст HTTP-ошибки. */ } }
      if (active) setError(message);
    });
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [orderId, screen._id]);
  return <OrderDialog title={screen.name || 'Файл заказа'} onClose={onClose}>{error ? <div className="orders-message orders-message--danger" role="alert">{error}</div> : !asset ? <div role="status">Загрузка файла…</div> : <><div className="orders-attachment-preview">{asset.type.startsWith('image/') ? <img src={asset.url} alt={screen.name || 'Файл заказа'} /> : <iframe src={asset.url} title={screen.name || 'Файл заказа'} />}</div><a className="orders-btn" href={asset.url} download={screen.name || 'order-file'}>Скачать</a></>}</OrderDialog>;
}
export default function OrderAttachments({ order }) {
  const [selected, setSelected] = useState(null);
  if (!order.orderScreens?.length) return null;
  return <section className="orders-section"><h2>Файлы заказа</h2><div className="orders-file-list">{order.orderScreens.map((screen) => <button key={screen._id} type="button" className="orders-btn" onClick={() => setSelected(screen)}>{screen.type === 'scene' ? 'Сцена' : 'Фото'} · {screen.name || 'Открыть файл'}</button>)}</div>{selected && <Attachment orderId={order._id} screen={selected} onClose={() => setSelected(null)} />}</section>;
}
